import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import { getOrientation, getToken } from '../../lib';
import { Card, CardText } from 'material-ui/Card';
import moment from 'moment'
import FlatButton from 'material-ui/FlatButton';
import DatePicker from 'material-ui/DatePicker';
import TextField from 'material-ui/TextField'
import { FormattedMessage } from 'react-intl';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import TranscriptionTable from './TranscriptionTable';

class Transcriptions extends Component {
  state = {
    startDate: null,
    endDate: null,
    searchText: '',
    isSearched: false
  };
  componentDidMount() {
    this.initState();
  }

  initState = () => {
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const searchText = sessionStorage.getItem('searchText');

    this.setState({ 
      startDate : startDate && this.isValidDate(new Date(startDate)) ? new Date(startDate) : '', 
      endDate : endDate && this.isValidDate(new Date(endDate)) ? new Date(endDate) : '', 
      searchText: searchText && searchText !== 'null' ? searchText : ''
    }, () => {
      if(this.state.startDate || this.state.endDate || this.state.searchText) {
        this.performSearch();
        this.setState({ isSearched: true })
      }
    });

    if(!startDate && !endDate && !searchText) {
      this.props.resetSearch();
    }
  }

   isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
  }

  transcriptionInfo(transcription) {
    this.props.history.push({
      pathname: '/admin/transcription-info',
      state: { transcription, searchText: this.state.searchText },
    });
  }

  goToTranscriptionGroup() {
    this.props.history.push({
      pathname: '/admin/transcription-group',
      state: { recordings: this.props.roomRecordings.filter(r => r.video_transcription !== null)}
    })
  }

  performSearch = () => {
    sessionStorage.setItem('startDate', this.state.startDate);
    sessionStorage.setItem('endDate', this.state.endDate);
    sessionStorage.setItem('searchText', this.state.searchText);
    const token = getToken();
    let searchObject = { search: this.state.searchText};
    if (this.state.startDate) {
      searchObject['start_date'] = this.state.startDate.getFullYear() + '-' + (this.state.startDate.getMonth() + 1)  + '-' + this.state.startDate.getDate()
    }

    if (this.state.endDate) {
      searchObject['end_date'] = this.state.endDate.getFullYear() + '-' + (this.state.endDate.getMonth() + 1)  + '-' + this.state.endDate.getDate()
    }
    this.props.fetchRoomRecordings(token, true, searchObject);
    this.setState({ isSearched: true });
  }
  

  clearSearch = () => {
    sessionStorage.clear();
    this.setState({startDate: null, endDate: null, searchText: '', isSearched: false })
    this.props.resetSearch();
  }

  render() {
    return (
      <Paper
        style={{
          padding: '16px',
          borderRadius: 'none',
          border: '1px solid #cecece',
          boxShadow: 'none',
          marginBottom: '16px',
        }}
      >
        <div>
          <FlatButton
            onClick={() => this.props.history.goBack()}
            icon={<NavigationArrowBack color="#3659A0" style={{ marginLeft: 0 }} />}
            label={<FormattedMessage id="transcriptions.back" />}
            labelStyle={{
              color: '#3659A0',
            }}
            style={{
              marginBottom: '5px',
            }}
          />
        </div>
        <div
          style={{
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <FormattedMessage id="transcriptions.transcriptions" />
          {/* <FlatButton
              onClick={() => this.goToTranscriptionGroup()}
              label={<FormattedMessage id="transcriptions.viewAll" />}
              labelStyle={{
                color: '#3659A0',
              }}
            /> */}
        </div>

        <div
          style={{
            fontSize: '18px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
          className='transcription-action'
        >
          <DatePicker 
            container='inline'
            hintText={<FormattedMessage id="transcriptions.startDate" />}
            value={this.state.startDate}
            maxDate={new Date()}
            className='transcription-date-picker'
            onChange={(e, newValue) => { this.setState({startDate: newValue }) }}
            style={{
              marginRight: '12px',
              flexGrow: 100
            }}
            mode={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'landscape' : 'portrait'}
          />
          <DatePicker 
            container='inline'
            hintText={<FormattedMessage id="transcriptions.endDate" />}
            minDate={this.state.startDate}
            maxDate={new Date()}
            value={this.state.endDate}
            className='transcription-date-picker'
            onChange={(e, newValue) => { this.setState({endDate: newValue }) }}
            style={{
              marginRight: '12px',
              flexGrow: 100
            }}
            mode={getOrientation() === 'landscape' && this.props.view === 'mobile' ? 'landscape' : 'portrait'}
          />

          <TextField
            hintText={<FormattedMessage id="transcriptions.textToSearch" />}
            onChange={(e) => { this.setState({searchText: e.target.value })}}
            value={this.state.searchText}
            style={{
              marginRight: '12px'
            }}
            className='transcription-search-input'
          />

          <FlatButton
            label={<FormattedMessage id="transcriptions.search" />}
            hoverColor="#c59d3f"
            backgroundColor="#f1b62e"
            onClick={this.performSearch}
            labelStyle={{ color: '#FFFFFF' }}
            style={{ marginRight: '12px' }}
          />

          <FlatButton
            label={<FormattedMessage id="transcriptions.clearSearch" />}
            onClick={this.clearSearch}
          />
        </div>

        {this.state.isSearched && <TranscriptionTable
          transcriptions={this.props.roomRecordings}
          transcriptionInfo={(t) => this.transcriptionInfo(t)}
          isFetching={this.props.isFetching}
        />}
        <Card></Card>
      </Paper>
    );
  }
}

export default Transcriptions;



// WEBPACK FOOTER //
// src/routes/Transcriptions/Transcriptions.js